import { ToolkitProperty, expected } from '@aloft/toolkit-shared';

import { PairedSaleIDs } from '../../types.ts';
import { PairedSalesTableRow } from './types.ts';

export const makePairedSalesTableRows = ({
  pairs,
  properties,
}: {
  pairs: PairedSaleIDs[];
  properties: Record<string, ToolkitProperty>;
}): PairedSalesTableRow[] =>
  pairs.map((pair) => ({
    p1: expected(properties[pair.p1]),
    p2: expected(properties[pair.p2]),
  }));
